import { Component } from '@angular/core';
import { versionInfo } from '../../../../version';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {
  get version(): string | null {
    return versionInfo.version !== 'VERSION_PLACEHOLDER' ? versionInfo.version : null;
  }

  get commit(): string {
    return versionInfo.commit !== 'COMMIT_PLACEHOLDER' ? versionInfo.commit : '';
  }
}
